import React, {forwardRef,useState,useImperativeHandle} from 'react'
import {Button, Modal, Radio, message} from 'antd'
import moment from "moment";
import Tools from '../tools/Tools'
import WWTable from '../components/Table'
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;
let statusObj = {
    '1':Strings.rs14383,
    '0':Strings.rs14384,
    '3':Strings.rs14385
}
function InstructHistory(props,ref) {
    const [visible,setVisible] = useState(false)
    const [status,setStatus] = useState('')
    const [id,setId] = useState('')
    const [record,setRecord] = useState({})
    const [dataList,setDataList] = useState([])

    useImperativeHandle(ref, () => ({
        showModal: (record,status) => {
            setVisible(true)
            setId(record.taskDetailId)
            setStatus(status)
            setRecord(record)
            getHistoryList(record.taskDetailId,status)
        }
    }))

    function hideModal() {
        setVisible(false)
    }

    function getHistoryList(id,status) {
        let url = `${Tools.getApiUrl("taskHistoryList",this.props.platform)}taskDetailId=${id}`
        if(!Tools.isNull(status)){
            url += '&status='+status
        }
        Tools.fetch(url,'GET',function (data) {
            if(data.code === 0) {
                setDataList(data.data)
            } else {
                message.error(data.message)
            }
        })
    }

    let columns = [
        {
            title: Strings.rs10084,
            width: "15%",
            dataIndex: 'imei',
        }, {
            title: Strings.rs10026,//
            dataIndex: 'deviceName',
            width: "15%",
        }, {
            title: Strings.rs10158,
            dataIndex: 'status',
            width: "10%",
            render:(text, record, index) =>{
                return <span>{statusObj[record.status]}</span>
            }
        }, {
            title: Strings.rs10320,
            dataIndex: 'sendTime',
            width: "20%",
            render:(text, record, index) =>{
                return <span>{record.sendTime?moment(record.sendTime*1000).format("YYYY-MM-DD HH:mm:ss"):""}</span>
            }
        }, {
            title: Strings.rs10321,
            dataIndex: 'response',
            width: '20%'
        }, {
            title: Strings.rs10161,
            dataIndex: 'responseTime',
            width: '20%',
            render:(text, record, index) =>{
                return <span>{record.responseTime?moment(record.responseTime*1000).format("YYYY-MM-DD HH:mm:ss"):""}</span>
            }
        }];


    return <Modal transitionName="" maskTransitionName=""
                  className="default_modal wid1100"
                  width=""
                  visible={visible}
                  onCancel={hideModal}
                  maskClosable={false}
                  title={Strings.rs14388}
                  footer={null}>
        <RadioGroup onChange={(e)=>{
            setStatus(e.target.value)
            getHistoryList(id,e.target.value)
        }} value={status} className="mg_bottom13">
            <RadioButton value="">{Strings.rs10613}</RadioButton>
            <RadioButton value="1">{Strings.rs14383}</RadioButton>
            <RadioButton value="0">{Strings.rs14384}</RadioButton>
            <RadioButton value="3">{Strings.rs14385}</RadioButton>
        </RadioGroup>
        <div className="flex space_between mg_bottom10">
            <span>{record.instructionName}</span>
        </div>
        <WWTable className="new_app_table"
                 dataSource={dataList}
                 columns={columns}
                 hideShadow={true}
                 hiddenPagination={true}
                 innerHeight={600}/>
    </Modal>
}
export default forwardRef(InstructHistory)